module.exports = __webpack_public_path__ + "static/endVid-f43d665cf440cbe39a9fa0080e4065b3.mp4";